import { useContext, useRef, useEffect } from 'react'
import { Link } from 'gatsby'
import { LayoutContext } from 'utils/contextUtils'
import MushroomIcon from 'images/MCA_color_logo.svg'
import { MenuPanelContainer, NoUnderlineLink, MushroomImage } from './MenuPanelStyles.js'

const MenuPanel = ({ open, setOpen }) => {
  const { setShowHomeOverlay } = useContext(LayoutContext)
  const modalRef = useRef()

  useEffect(() => {
    const handleKeyPress = event => {
      if (!open) { return }
      if (event.key === 'Tab') {
        const tabbableElements = Array.from([document.getElementById('hamburger')])
          .concat(Array.from([document.getElementById('maintitle')]))
          .concat(Array.from(modalRef.current.querySelectorAll(['button', 'a'])))
        const firstButton = tabbableElements[0]
        const lastButton = tabbableElements[tabbableElements.length - 1]
        if (!tabbableElements.includes(document.activeElement)) {
          firstButton.focus()
          event.preventDefault()
        }
        else if (event.shiftKey) {
          if (document.activeElement === firstButton) {
            lastButton.focus()
            event.preventDefault()
          }
        }
        else if (document.activeElement === lastButton) {
          firstButton.focus()
          event.preventDefault()
        }
      }
    }
    const previousActiveElement = document.activeElement
    document.addEventListener('keydown', handleKeyPress)
    return () => {
      if (previousActiveElement) { previousActiveElement.focus() }
      document.removeEventListener('keydown', handleKeyPress)
    }
  }, [open])

  const onClick = () => {
    setOpen(false)
    setShowHomeOverlay(false)
  }

  return (
    <MenuPanelContainer open={open} ref={modalRef}>
      <Link to='/' onClick={onClick} tabIndex={open ? 0 : -1}>
        <MushroomImage src={MushroomIcon} alt='home' />
      </Link>
      <NoUnderlineLink to='/posts' onClick={onClick} tabIndex={open ? 0 : -1}>Posts</NoUnderlineLink>
      <NoUnderlineLink to='/mushrooms' onClick={onClick} tabIndex={open ? 0 : -1}>Index</NoUnderlineLink>
      <NoUnderlineLink to='/process' onClick={onClick} tabIndex={open ? 0 : -1}>Process</NoUnderlineLink>
      <NoUnderlineLink to='/about' onClick={onClick} tabIndex={open ? 0 : -1}>About</NoUnderlineLink>
    </MenuPanelContainer>
  )
}

export default MenuPanel
